import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Styles } from '../../../css/table';
import { TablePagination } from '../../common/table/tablePagination';
import { assessmentConfigColumn } from '../../common/table/TableColumns/assessmentConfig';

const AssessmentTable = ({ pageCount, fetchData }) => {
  const { assessmentConfigs } = useSelector(state => state.gameConfig);

  return (
    <div className="w-full h-full">
      <Styles>
        <TablePagination
          columns={assessmentConfigColumn}
          data={assessmentConfigs?.data || []}
          total_item={assessmentConfigs?.total_items}
          fetchData={fetchData}
          pageCount={pageCount}
          className="rounded"
        />
      </Styles>
    </div>
  );
};
AssessmentTable.propTypes = {
  fetchData: PropTypes.func,
  pageCount: PropTypes.number,
};
export default AssessmentTable;
